// @flow

import type { EmployeeSmsNotificationsState } from "./types";

export const initialState: EmployeeSmsNotificationsState = {
  requestsInProgress: 0,
  settings: null,
  schema: null,
  smsRules: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },
  current: null,
  assignments: [],
  modals: {
    showAddModal: false,
    showEditModal: false,
    showDeleteModal: false,
  },
};

export default initialState;
